import { FaSearch, FaCheck, FaClock } from "react-icons/fa";

export default function TablaPedidos({
  pedidos,
  loading,
  puedeGestionar,
  onSelectPedido,
  onCambiarEstado,
  onCancelarPedido,
  calcularTotalPedido,
}) {
  /* ======================================================
     DESKTOP TABLE
  ====================================================== */
  return (
    <>
      <div
        className="hidden md:block overflow-x-auto rounded-xl
                   border border-slate-200 dark:border-slate-800
                   bg-white dark:bg-slate-900"
      >
        <table className="w-full min-w-[950px] text-sm">
          <thead className="bg-slate-100 text-slate-700 dark:bg-slate-950 dark:text-slate-200">
            <tr>
              <th className="px-4 py-2 text-left">ID</th>
              <th className="px-4 py-2 text-center">Mesa</th>
              <th className="px-4 py-2 text-center">Mesero</th>
              <th className="px-4 py-2 text-center">Fecha</th>
              <th className="px-4 py-2 text-center">Descripción</th>
              <th className="px-4 py-2 text-center">Total</th>
              <th className="px-4 py-2 text-center">Estado</th>
              <th className="px-4 py-2 text-center">Facturado</th>
              <th className="px-4 py-2 text-center">Acciones</th>
            </tr>
          </thead>

          <tbody className="text-slate-700 dark:text-slate-200">
            {pedidos.length === 0 ? (
              <tr>
                <td
                  colSpan="9"
                  className="px-4 py-6 text-center text-slate-500 dark:text-slate-400"
                >
                  {loading
                    ? "Cargando pedidos..."
                    : "No hay pedidos disponibles"}
                </td>
              </tr>
            ) : (
              pedidos.map((pedido) => (
                <tr
                  key={pedido.id}
                  className="
                    odd:bg-white even:bg-slate-50
                    dark:odd:bg-slate-900 dark:even:bg-slate-800
                    hover:bg-slate-100 dark:hover:bg-slate-700
                    transition-colors
                  "
                >
                  <td className="px-4 py-2">{pedido.id}</td>
                  <td className="px-4 py-2 text-center">
                    {pedido.mesa?.numero || "—"}
                  </td>
                  <td className="px-4 py-2 text-center">
                    {pedido.mesero?.nombre || "—"}
                  </td>
                  <td className="px-4 py-2 text-center">
                    {new Date(pedido.fecha).toLocaleString()}
                  </td>
                  <td className="px-4 py-2 text-center">
                    {pedido.descripcion || "—"}
                  </td>
                  <td className="px-4 py-2 text-center font-semibold">
                    ${calcularTotalPedido(pedido).toFixed(2)}
                  </td>

                  <td className="px-4 py-2 text-center">
                    <EstadoBadge entregado={pedido.entregado} />
                  </td>

                  <td className="px-4 py-2 text-center">
                    <FacturadoBadge facturado={pedido.facturado} />
                  </td>

                  <td className="px-4 py-2 text-center">
                    <Acciones
                      pedido={pedido}
                      puedeGestionar={puedeGestionar}
                      onSelectPedido={onSelectPedido}
                      onCambiarEstado={onCambiarEstado}
                      onCancelarPedido={onCancelarPedido}
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* ======================================================
         MOBILE CARDS (🔥 AQUÍ ESTABA EL PROBLEMA)
      ====================================================== */}
      <div className="md:hidden space-y-4">
        {pedidos.map((pedido) => (
          <div
            key={pedido.id}
            className="
              rounded-2xl
              bg-white dark:bg-slate-800/90
              border border-slate-200 dark:border-slate-700
              p-4 shadow-md
              text-sm text-slate-700 dark:text-slate-200
            "
          >
            {/* Header */}
            <div className="flex justify-between items-center mb-3">
              <span className="font-semibold text-slate-900 dark:text-white">
                Pedido #{pedido.id}
              </span>

              <span className="font-bold text-emerald-600 dark:text-emerald-400">
                ${calcularTotalPedido(pedido).toFixed(2)}
              </span>
            </div>

            {/* Info */}
            <div className="space-y-1 text-slate-600 dark:text-slate-300">
              <div><b>Mesa:</b> {pedido.mesa?.numero || "—"}</div>
              <div><b>Mesero:</b> {pedido.mesero?.nombre || "—"}</div>
              <div>
                <b>Fecha:</b>{" "}
                {new Date(pedido.fecha).toLocaleString()}
              </div>
              {pedido.descripcion && (
                <div>
                  <b>Descripción:</b> {pedido.descripcion}
                </div>
              )}
            </div>

            {/* Badges */}
            <div className="flex flex-wrap gap-2 mt-3">
              <EstadoBadge entregado={pedido.entregado} />
              <FacturadoBadge facturado={pedido.facturado} />
            </div>

            {/* Acciones (CTA REAL) */}
            <div className="mt-4 space-y-2">
              <button
                onClick={() => onSelectPedido(pedido)}
                className="
                  w-full flex items-center justify-center gap-2
                  px-4 py-2 rounded-xl
                  text-sm font-semibold
                  bg-sky-500/15 text-sky-400
                  border border-sky-500/40
                  hover:bg-sky-500 hover:text-slate-900
                  transition-colors
                "
              >
                <FaSearch />
                Ver detalle
              </button>

              {puedeGestionar && (
                <button
                  onClick={() => onCambiarEstado(pedido)}
                  className={`
                    w-full px-4 py-2 rounded-xl
                    text-sm font-semibold
                    border transition-colors
                    ${
                      pedido.entregado
                        ? "border-amber-500 text-amber-400 hover:bg-amber-500 hover:text-slate-900"
                        : "border-emerald-500 text-emerald-400 hover:bg-emerald-500 hover:text-slate-900"
                    }
                  `}
                >
                  {pedido.entregado
                    ? "Marcar pendiente"
                    : "Marcar entregado"}
                </button>
              )}

              {puedeGestionar && !pedido.facturado && !pedido.cancelado && (
                <button
                  onClick={() => onCancelarPedido(pedido)}
                  className="
                    w-full px-4 py-2 rounded-xl
                    text-sm font-semibold
                    border border-rose-500 text-rose-400
                    hover:bg-rose-500 hover:text-slate-900
                    transition-colors
                  "
                >
                  ✖ Anular pedido
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

/* ======================================================
   SUBCOMPONENTES
====================================================== */

const EstadoBadge = ({ entregado }) => (
  <span
    className={`inline-flex items-center gap-1
                px-3 py-1.5 rounded-full
                text-xs font-semibold border ${
      entregado
        ? "bg-emerald-500/20 text-emerald-400 border-emerald-500/60"
        : "bg-amber-500/20 text-amber-400 border-amber-500/60"
    }`}
  >
    {entregado ? <FaCheck /> : <FaClock />}
    {entregado ? "Entregado" : "Pendiente"}
  </span>
);

const FacturadoBadge = ({ facturado }) => (
  <span
    className={`inline-flex items-center
                px-3 py-1.5 rounded-full
                text-xs font-semibold border ${
      facturado
        ? "bg-emerald-500/20 text-emerald-400 border-emerald-500/60"
        : "bg-rose-500/20 text-rose-400 border-rose-500/60"
    }`}
  >
    {facturado ? "Facturado" : "No facturado"}
  </span>
);

const Acciones = ({
  pedido,
  puedeGestionar,
  onSelectPedido,
  onCambiarEstado,
  onCancelarPedido,
}) => (
  <div className="flex flex-wrap justify-center gap-2">
    <button
      onClick={() => onSelectPedido(pedido)}
      className="px-3 py-1.5 rounded-lg text-xs font-medium
                 border border-sky-500 text-sky-400
                 hover:bg-sky-500 hover:text-slate-900 transition-colors"
    >
      <FaSearch /> Ver
    </button>

    {puedeGestionar && (
      <button
        onClick={() => onCambiarEstado(pedido)}
        className={`px-3 py-1.5 rounded-lg text-xs font-medium border ${
          pedido.entregado
            ? "border-amber-500 text-amber-400"
            : "border-emerald-500 text-emerald-400"
        }`}
      >
        {pedido.entregado ? "Pendiente" : "Entregado"}
      </button>
    )}

    {puedeGestionar && !pedido.facturado && !pedido.cancelado && (
      <button
        onClick={() => onCancelarPedido(pedido)}
        className="px-3 py-1.5 rounded-lg text-xs font-medium
                   border border-rose-500 text-rose-400"
      >
        ✖
      </button>
    )}
  </div>
);
